import { httpClient } from '@/lib/api/httpClient'
import type { AccountSignupInput, AccountSigninInput, AccountOTPVerifyInput, AccountMeResponse } from '@/shared/types'

export const authApi = {
  register: async (data: AccountSignupInput) => {
    const response = await httpClient.post('/vendor/auth/register', data)
    return response.data
  },

  login: async (data: AccountSigninInput) => {
    const response = await httpClient.post('/vendor/auth/login', data)
    return response.data
  },

  verifyOtp: async (data: AccountOTPVerifyInput) => {
    const { phone, otp } = data
    const response = await httpClient.post(`/vendor/auth/verify-otp/${phone}`, { otp })
    return response.data
  },

  getMe: async (): Promise<AccountMeResponse> => {
    const response = await httpClient.get('/vendor/account/me')
    return response.data?.data?.details
  },
}
